
import { ref, onMounted } from 'vue';
import { ISupportCategory, ISupportCategoryTopLevel } from "VueInterfaces/Interfaces";
import SupportCategoriesCard from "VueComponents/SupportCategories/SupportCategoriesCard.vue";
import { ISupportCategoriesAppTranslations } from "VueInterfaces/Interfaces";

export default {
	name: "SupportCategoriesNav",
	components: {
		SupportCategoriesCard
	},
	setup() {
		const supportCategories = ref<ISupportCategory[]>([]);
		const currentCategory = ref<ISupportCategory[]>([]);
		const categoryStack = ref([]);
		const translations = ref<ISupportCategoriesAppTranslations>({});
		const categoryDiv = document.getElementById('productCategoriesDataNav');

		const getSupportCategoriesData = async () => {
			let categoriesData:ISupportCategoryTopLevel = JSON.parse(categoryDiv.getAttribute('data-page-data'));
			supportCategories.value = categoriesData.SupportCategories;
			currentCategory.value = categoriesData.SupportCategories;
		};

		const setCurrentCategory = (childCategories) => {
			currentCategory.value = childCategories
		};

		const enterCategory = (currentCategory, childCategories) => {
			categoryStack.value.push(currentCategory);
			setCurrentCategory(childCategories);
		};

		const goBack = () => {
			setCurrentCategory(categoryStack.value.pop());
		};

		onMounted(() => {
			getSupportCategoriesData();
			translations.value = getTranslations();
		});

		const getTranslations = () => {
			return JSON.parse(categoryDiv.getAttribute('data-translations'));
		};

		return {
			supportCategories,
			currentCategory,
			translations,
			categoryStack,
			getSupportCategoriesData,
			setCurrentCategory,
			enterCategory,
			goBack,
			getTranslations
		};
	},
};
